import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useUser();
    const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('token');

    if (loading || (!user && hasToken)) {
        return <div className="page"><p>Loading...</p></div>;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute;
